import { AuthnTransaction } from '@okta/okta-auth-js';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import mapMfaFactorsFromAuthnTransaction from 'utils/mfaFactorHelpers';

const useHandleMfaEnrollment = () => {
  const navigate = useNavigate();
  const handleMfaEnrollment = useCallback(
    async (result: AuthnTransaction, username: string) => {
      const factors = mapMfaFactorsFromAuthnTransaction(result);

      const newState = {
        username,
        factors,
      };
      navigate('/login/mfa/enrollment', {
        state: newState,
      });
    },
    [navigate],
  );
  return handleMfaEnrollment;
};

export default useHandleMfaEnrollment;
